module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('radio-buttons', {
    attrs: {
      "value": _vm.value,
      "options": _vm.targetTypes,
      "on-select": _vm.onSelect,
      "disabled": _vm.disabled
    },
    on: {
      "input": function (val) { return _vm.$emit('input', val); }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71340b87","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/createTarget/components/UploadTargetRadioButtons.vue
// module id = 2128
// module chunks = 0